import { ChangeDetectorRef, Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/core/common-services/user.services';
import { AuthenticationService } from 'src/app/core/data-services/authentication.service';
import { SessionTimeoutService } from 'src/app/core/common-services/session-timeout.service';
import { ConnectionService } from 'src/app/core/common-services/connection.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'JARI-SOLUTIONS';
  currentSystemLanguage: string = 'en-US';
  style: boolean = false;
  isOffline: boolean = false;

  private routerSubscription?: Subscription;
  private connectionSubscription?: Subscription;

  constructor(
    public router: Router,
    private userService: UserService,
    private _elementRef: ElementRef,
    private sessionTimeoutService: SessionTimeoutService,
    private authenticationService: AuthenticationService,
    private connectionService: ConnectionService
  ) {
  }

  logout() {
    this.authenticationService.logout().subscribe({
      next: () => {
        this.userService.logout();
      },
      error: () => {
        this.userService.logout();
      }
    });
  }
  
  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute("ng-version");

    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.isLoggedIn()) {
        this.sessionTimeoutService.startTimer();
      } else {
        this.sessionTimeoutService.stopTimer();
      }
    });

    this.connectionSubscription = this.connectionService.isOnline$.subscribe(
      (isOnline) => {
        this.isOffline = !isOnline;
      }
    );
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.connectionSubscription) {
      this.connectionSubscription.unsubscribe();
    }
  }

  get offlineMessage(): string {
    return this.connectionService.getNoInternetMessage();
  }

  isLoggedIn() {
    return this.userService.currentUserCredantials!=undefined&&this.userService.isLoggedIn();
  }

  
  // Each toast's X closes only that toast, so an error and a success can be on screen together.
  close(type: 'error' | 'warning' | 'success') {
    const message = document.getElementById(`${type}Msg`);
    if (message) {
      message.innerHTML = '';
    }
    const shown = document.getElementsByClassName(`${type}_toaster_show`);
    if (shown.length > 0) {
      shown[0].setAttribute('class', `${type}_toaster`);
    }
  }
}
